export const indicatorRenderer = (
        clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
        isSelected: boolean,
        index: number
    ) => {
        return (
            isSelected ? (
                <li
                    key={index}
                    style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '20px',
                        backgroundColor: '#45B9AE'
                    }}
                />
            ) : (
                <li
                    key={index}
                    value={index}
                    onClick={clickHandler}
                    onKeyDown={clickHandler}
                    style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '16px',
                        backgroundColor: '#DCF5F2',
                        cursor: 'pointer'
                    }}
                />
            )
        );
    };